import { useEffect, useState } from "react";
import "../index.css";
import RequestConfig from "../mini_components/RequestConfig";
import CountUp from "react-countup";

function HomePage() {
  const [data, setData] = useState([]);
  const [isPending, setIsPending] = useState(true);

  useEffect(() => {
    setIsPending(true);

    RequestConfig.get(`/reports/statements/summary/`)
      .then((response) => {
        if (response.status === 200) {
          setData(response.data);
        }
      })
      .catch((err) => {
        //console.log(err);
        setData([]);
      })
      .finally(() => {
        setIsPending(false);
      });
  }, []);

  return (
    <>
      {isPending ? (
        Array.apply(null, Array(3)).map((_, index) => (
          <div
            key={index}
            className="w-full min-h-[100px] bg-neutral-10 justify-center rounded-xl p-6 animate-pulse "
          ></div>
        ))
      ) : (
        <div className="grid grid-cols-2  gap-2 w-full">
          {data.map((item, index) => (
            <Card
              key={index}
              imageSrc={item.image}
              title={item.fa_key}
              value={item.value}
              en_key={item.key}
            />
          ))}
        </div>
      )}
    </>
  );
}

const Card = ({ imageSrc, title, value, en_key }) => (
  <div className=" col-span-1 bg-white py-8 flex flex-col gap-4 items-center rounded-[12px] ">
    <h4 className=" font-semibold text-[12px] truncate">{title}</h4>
    <div className="text-neutral-90 font-semibold text-[16px] md:text-[24px] truncate" dir="ltr">
      <CountUp start={0} end={value} delay={0} duration={1}>
        {({ countUpRef }) => (
          <div>
            <span ref={countUpRef} />
          </div>
        )}
      </CountUp>
    </div>
    {[
      "current_rial_balance",
      "withdraw_summation",
      "income_summation",
    ].includes(en_key) && <p>RIAL</p>}
  </div>
);

export default HomePage;
